import { render, staticRenderFns } from "./producer-company-list.vue?vue&type=template&id=5a78eb8d&"
import script from "./producer-company-list.vue?vue&type=script&lang=js&"
export * from "./producer-company-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports